import React from 'react'
import { AnimatedLogo, Button, createStyles, withStyles, Typography } from '@paintscout/ui'
import type { WithStyles, MuiTheme as Theme } from '@paintscout/ui'

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: '75vh',
      color: '#757575',
      width: '100vw',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    message: {
      marginTop: 24,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 12,
      maxWidth: 360,
      textAlign: 'center'
    },
    heading: {
      color: theme.paintscout.palette.brand.Neutral.P30
    }
  })

/**
 * Shown instead of the normal loading/login flow when the app is both embedded in an iframe and
 * has no existing session. In that state, react-auth0's Authorizer would otherwise redirect the
 * iframe to Auth0's universal login, which refuses to render in a frame (frame-ancestors) —
 * leaving a blank, permanently unresponsive iframe with no way out. Most commonly hit on iOS
 * Safari, which partitions cross-origin iframe storage away from any top-level session; desktop
 * browsers are less strict and can already see an existing session, so they're unaffected (#19007).
 */
function EmbeddedAppNotice(props: WithStyles<typeof styles>) {
  const { classes } = props

  return (
    <div className={classes.root} data-testid="embedded-app-notice">
      <AnimatedLogo scale={0.21} />
      <div className={classes.message}>
        <Typography variant="overline" classes={{ root: classes.heading }}>
          PaintScout can&apos;t open here
        </Typography>
        <Typography variant="body2">
          This page can&apos;t sign you in while PaintScout is embedded in another site. Open PaintScout in its own tab
          to continue.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => window.open(window.location.href, '_blank')}>
          Open PaintScout in a New Tab
        </Button>
      </div>
    </div>
  )
}

export default withStyles(styles)(EmbeddedAppNotice)
